jQuery(function($){

  //filter show/hide 

  //color
  $('.titlecolor').on('click',function(){
    if(!$( ".list_color" ).is( ":visible" )){
      $(this).find('i').removeClass('fa-angle-right').addClass('fa-angle-down');
    }else{
      $(this).find('i').removeClass('fa-angle-down').addClass('fa-angle-right');
    }
    $('.list_color').toggle();
  });

  //size
  $('.titlesize').on('click',function(){
    if(!$( ".list-size" ).is( ":visible" )){
      $(this).find('i').removeClass('fa-angle-right').addClass('fa-angle-down');
    }else{
      $(this).find('i').removeClass('fa-angle-down').addClass('fa-angle-right');
    }
    $('.list-size').toggle();
  });

  //occasion

  $('.titletag').on('click',function(){
    if(!$( ".list-tag" ).is( ":visible" )){
      $(this).find('i').removeClass('fa-angle-right').addClass('fa-angle-down');
    }else{
      $(this).find('i').removeClass('fa-angle-down').addClass('fa-angle-right');
    }
    $('.list-tag').toggle();
  });


  //categories

  $('.titlecat').on('click',function(){
    if(!$( ".widget-content" ).is( ":visible" )){
      $(this).find('i').removeClass('fa-angle-right').addClass('fa-angle-down');
    }else{
      $(this).find('i').removeClass('fa-angle-down').addClass('fa-angle-right');
    }
    $('.widget-content').toggle();
  });

  //custom wear it slider
  if($('#customwearit').length>0){
    $('#customwearit').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1, 
      responsive:[
        {
          breakpoint: 921,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false, 
            slidesToShow: 2
          }
        }, 
        {
          breakpoint: 425,
          settings: {
            arrows: false, 
            slidesToShow: 1
          }
        }
      ]
    });
  }
  if($('#customwearit2').length>0){
    $('#customwearit2').slick({
      infinite: false,
      dots:false,
      arrows:true,
      slidesToShow: 4,
      slidesToScroll: 1, 
      responsive:[
        {
          breakpoint: 921,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false, 
            slidesToShow: 2,
            dots:true
          }
        }, 
        {
          breakpoint: 425,
          settings: {
            arrows: false, 
            slidesToShow: 1,
            dots:true
          }
        }
      ]
    });
  }

  if($('#customwearit3').length>0){
    $('#customwearit3').slick({
      infinite: false,
      dots:true,
      arrows:true,
      slidesToShow: 3,
      slidesToScroll: 1, 
      responsive:[
        {
          breakpoint: 921,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false, 
            slidesToShow: 2,
            dots:true
          }
        }, 
        {
          breakpoint: 425,
          settings: {
            arrows: false, 
            slidesToShow: 1,
            dots:true
          }
        }
      ]
    });
  }
  //user location
  $.get("https://ipinfo.io/json", function (response) {
    //here you get details in response.
    console.log(response);
    var userip = response.ip;
    var countryname = response.city;
    var countrycode = response.country.toLowerCase();
    var flag = 'https://ipdata.co/flags/'+"us"+'.png';
    $('#imgflg').attr('src',flag);
  }, "jsonp");

  const collectionWrapper = $(".customwearitpage .list-category"),
        collectionSlider = collectionWrapper.slick({
          slidesToShow:2, 
          responsive:[
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                dots: false, 
                arrows:false
              }
            }]
        })



  if($(window).width() > 767){
    const containerWidth = collectionWrapper.width(), 
          containerHeight = collectionWrapper.height();


    let slidestyle = `<style>
.customwearitpage .list-category .slick-current{
width:${containerWidth*0.4}px !important; 	
}
.customwearitpage .list-category .slick-current img{
height:${containerHeight-50}px !important;
object-fit:cover;
}
.customwearitpage .list-category .slick-current + .slick-slide{
width:${containerWidth*0.6}px !important; 		
}
</style>`;

    $("body").prepend(slidestyle); 

  }



});

$("li.nav-item.dropdown").hover(function(){
$("a.delay03.relative.nav-link.menu_lv1").removeClass('active');
$(this).find("a").addClass('active');
});
$("li.nav-item.dropdown").click(function(){
$("a.delay03.relative.nav-link.menu_lv1").removeClass('active');
$(this).find("a").addClass('active');
});

$(".maxus-color").change(function(){

$("button.GiftWizard-gift-button.shop-button.enj-add-to-cart-btn.engoj-btn-addtocart.gwbutton").text('Send as a Gift');
  });
$(".maxus-color").click(function(){
if ($(this).hasClass("noavailable_variant")) {
var currentUrl = window.location.href;
var get_id = $(this).find("input").attr('data-id');
if (history.pushState) {
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?variant='+get_id+'';
    window.history.pushState({path:newurl},'',newurl);
}

}
});
$('.slider_class_valentine').slick({
    infinite: false,
      dots:true,
      arrows:true,
      slidesToShow: 4,
      slidesToScroll: 1, 
  rows: 0,
      responsive:[
        {
          breakpoint: 921,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false, 
            slidesToShow: 3,
            dots:true
          }
        }, 
        {
          breakpoint: 425,
          settings: {
            arrows: false, 
            slidesToShow: 2,
            dots:true
          }
        }
      ]
});

$('.products_slider_wrappper').slick({
    infinite: false,
      dots:true,
      arrows:true,
      slidesToShow: 4,
      slidesToScroll: 1, 
  	  rows: 0,
      responsive:[
        {
          breakpoint: 921,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false, 
            slidesToShow: 3,
            dots:true
          }
        }, 
        {
          breakpoint: 425,
          settings: {
            arrows: false, 
            slidesToShow: 2,
            dots:true
          }
        }
      ]
});

  

$(document).on("click","button.tablinks",function(){

$('.slider_class_valentine').slick('refresh');


});
$(".product_wrapper_inner input").change(function(){
if($(".product_wrapper_inner input").is(':checked')){
$(".custom_button").removeClass('hide');
$(".main_add_cart_button").addClass('hide');
     // Code in the case checkbox is checked.
} else {
$(".custom_button").addClass('hide');
$(".main_add_cart_button").removeClass('hide');
     // Code in the case checkbox is NOT checked.
}
});
$(document).on('click','.custom_button', function(){
  jsonObj = [];

    var current_variant = $(this).find(".bundle_items").attr('data-id');
    item = {}
    item ["id"] = parseInt(current_variant);
    item ["quantity"] = 1;
    jsonObj.push(item);

  $('input.bundle_items:checked').each(function(){
      var total_ids= $(this).val();
      //alert(total_ids);

      item2 = {}
      item2 ["id"] = parseInt(total_ids);
      item2 ["quantity"] = 1;
      jsonObj.push(item2);

    });

    $.ajax({
      type: "POST", 
      url: '/cart/add.js',
      data: {items: jsonObj },
      dataType: "json",
      success: function() {
		  document.location.href='/cart';
      },
	 error: function(jqxhr, textStatus, error) {
var myObj = jqxhr.responseText;
const myJSON = myObj;
const myObj2 = JSON.parse(myJSON);
$(".custom_error_msg").removeClass('hide');
 $(".custom_error_msg").text(myObj2["description"]);  
	
  }
    
    });

  });  
